<template>
  <div class="mt-3">
    <RadioGroup :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" class="mb-0">
      <RadioGroupLabel class="block text-sm font-semibold text-gray-900">Appareils et type d'offre</RadioGroupLabel>
      <p class="mt-0.5 text-xs italic text-gray-600">Que souhaitez-vous assurer ?</p>
      <div class="flex gap-2 mt-2 flex-col">
        <RadioGroupOption as="template" value="mobile_protection" v-slot="{ checked }">
          <div
            :class="[
              'relative flex border-2 p-2.5 rounded-lg cursor-pointer transition-colors',
              checked ? 'border-primary-dark bg-primary-light' : 'border-gray-300 bg-white hover:border-primary',
            ]"
          >
            <span class="flex flex-1 flex-col gap-0.5">
              <span class="font-medium text-sm text-gray-900">UN SEUL TÉLÉPHONE</span>
              <span class="text-xs font-semibold text-gray-700">📱 Mobile Protection</span>
              <span class="text-xs text-gray-600">→ Uniquement votre téléphone · Casse + Oxydation + Vol</span>
            </span>
            <span v-if="checked" class="text-primary-dark text-base">✓</span>
          </div>
        </RadioGroupOption>
        <RadioGroupOption as="template" value="connect_protection" v-slot="{ checked }">
          <div
            :class="[
              'relative flex border-2 p-2.5 rounded-lg cursor-pointer transition-colors',
              checked ? 'border-primary-dark bg-primary-light' : 'border-gray-300 bg-white hover:border-primary',
            ]"
          >
            <span class="flex flex-1 flex-col gap-0.5">
              <span class="font-medium text-sm text-gray-900">TOUS MES APPAREILS DU FOYER (HORS TÉLÉPHONE)</span>
              <span class="text-xs font-semibold text-gray-700">🏠 Connect Protection</span>
              <span class="text-xs text-gray-600">→ PC, tablette, console... · Casse + Oxydation + Vol + PANNE</span>
            </span>
            <span v-if="checked" class="text-primary-dark text-base">✓</span>
          </div>
        </RadioGroupOption>
      </div>
    </RadioGroup>
    <ErrorMessage name="offerType" class="mt-1 text-xs text-red-600" />
  </div>
</template>

<script>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";
import { ErrorMessage } from "vee-validate";

export default {
  components: {
    RadioGroup,
    RadioGroupLabel,
    RadioGroupOption,
    ErrorMessage,
  },
  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },
  emits: ["update:modelValue"],
};
</script>
